import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FirebaseAppProvider} from 'reactfire';


export const firebaseConfig = {
  apiKey: "AIzaSyBRUi_McHDYmhJAzbKbAcTxR620cZEZ_D8",
  authDomain: "shows-dd443.firebaseapp.com",
  projectId: "shows-dd443",
  storageBucket: "shows-dd443.appspot.com",
  messagingSenderId: "1027611074072",
  appId: "1:1027611074072:web:ea7d14363326358b01ad6d",
  measurementId: "G-YKJCPXLMKZ"
};
ReactDOM.render(
  <React.StrictMode>
     <FirebaseAppProvider firebaseConfig={firebaseConfig}>
        <App />
    </FirebaseAppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
